import { OptimizePlanSignalRResultRequest } from "./optimize-plan-signalR-result-request";

export interface OptimizePlanSignalRRequest {
    successful: boolean;
    result: OptimizePlanSignalRResultRequest;
  }



  
  